import { useContext } from "react";
import { ThemeContext } from "./ThemeProvider";

export default function ThemeSettings() {
  const context = useContext(ThemeContext);

  if (!context) {
    return <h5>ThemeProvider Not Found</h5>;
  }

  const { applyTheme } = context;
  //onst context = useContext(ThemeContext);

  console.log("Theme Context:", context);

  if (!context) {
    return <h3>Theme Context Not Found</h3>;
  }
  return (
    <div className="card p-4">
      <div className="row">
        <div className="col-3">
          <button
            className="btn btn-primary w-100 mb-2"
            onClick={() => applyTheme("blue")}
          >
            {/* Blue */}
          </button>
        </div>
        <div className="col-3">
          <button
            className="btn btn-success w-100 mb-2"
            onClick={() => applyTheme("green")}
          >
            {/* Green */}
          </button>
        </div>

        <div className="col-3">
          <button
            className="btn btn-danger w-100 mb-2"
            onClick={() => applyTheme("red")}
          >
            {/* Red */}
          </button>
        </div>

        <div className="col-3">
          <button
            className="btn btn-purple w-100 mb-2"
            // style={{ background: "#6f42c1", color: "#fff" }}
            onClick={() => applyTheme("purple")}
          >
            {/* Purple */}
          </button>
        </div>
      </div>
    </div>
  );
}
